import { Stack } from '@mui/material';
import { Icon } from '@/units/index';

const formatDate = (date: Date) => {
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
  });
};

type Props = {
  fromDate: Date;
  toDate?: Date;
};

export function DateRange({ fromDate, toDate }: Props) {
  return (
    <Stack direction="row" gap="5px" alignItems="center">
      <Icon.Calendar sx={{ fill: 'transparent', fontSize: '14px', stroke: '#667085' }} />

      <Stack
        direction="row"
        gap="3px"
        alignItems="center"
        sx={{
          overflow: 'hidden',
          color: 'var(--Gray-500, #667085)',
          textAlign: 'center',
          textOverflow: 'ellipsis',
          fontFamily: 'Inter',
          fontSize: '11px',
          fontStyle: 'normal',
          fontWeight: 400,
          lineHeight: '18px',
        }}
      >
        {formatDate(fromDate)}

        {toDate ? (
          <>
            <i className="fa-regular fa-arrow-right" style={{ fontSize: '10px' }} />
            {formatDate(toDate)}
          </>
        ) : null}
      </Stack>
    </Stack>
  );
}
